import { render, staticRenderFns } from "./TickerWithImage.vue?vue&type=template&id=6f3e25e8&scoped=true&"
import script from "./TickerWithImage.vue?vue&type=script&lang=js&"
export * from "./TickerWithImage.vue?vue&type=script&lang=js&"
import style0 from "./TickerWithImage.vue?vue&type=style&index=0&id=6f3e25e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3e25e8",
  null
  
)

export default component.exports